import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './48404219cb10939c86e5daacfa7d535fffaba81d8e00b9fd9aab9f417871c5f2.cfe-internal.js';
import { useToolbarContext } from './a160cf879b7cab120bf814e64f156f70cee237e5ec6d1ada4eef9b879e36d9b6.cfe-internal.js';
import '../IconButton/fa92464f43077b1cbdd0bb416ee549d83eadaee9906eab0987bbf0ad889eddad.cfe-internal.js';
import '../../icons/index.es.js';
import IconButtonWithLabel from './605bf36628a11924ba248af52d9933a9c308ca46be92fc848a17faf3182e87be.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';
import ExcludeIcon from '../../icons/components/bf40dd130c29ae927acffe928b5cf8001c5b30805752a75bd2371215ff824374.cfe-internal.js';

var _excluded = ["icon", "label", "className", "aria-controls", "id", "data-testid"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var getPrevIndex = function getPrevIndex(currentIndex, numItems) {
  return (currentIndex - 1 + numItems) % numItems;
};
var getNextIndex = function getNextIndex(currentIndex, numItems) {
  return (currentIndex + 1) % numItems;
};
var ToolbarTab = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _context, _context2;
  var Icon = _ref.icon,
    label = _ref.label,
    className = _ref.className,
    ariaControls = _ref['aria-controls'],
    id = _ref.id,
    dataTestId = _ref['data-testid'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useToolbarContext = useToolbarContext(),
    focusedIndex = _useToolbarContext.focusedIndex,
    selectedIndex = _useToolbarContext.selectedIndex,
    setSelectedIndex = _useToolbarContext.setSelectedIndex,
    focusTab = _useToolbarContext.focusTab,
    isCollapsed = _useToolbarContext.isCollapsed,
    numTabs = _useToolbarContext.numTabs,
    index = _useToolbarContext.index,
    toolbarId = _useToolbarContext.id,
    rootDataTestId = _useToolbarContext.rootDataTestId;
  var isFocused = focusedIndex === index;
  var isSelected = selectedIndex === index;
  var handleSelect = function handleSelect() {
    setSelectedIndex === null || setSelectedIndex === void 0 || setSelectedIndex(Number(index));
  };
  var handleClick = function handleClick(e) {
    /*
     * In some browsers, clicking on a button does not focus the button.
     * This breaks the blur behavior of the `ToolbarTabs` container div.
     * By programmatically focusing the button, the blur behavior does not break.
     */
    e.currentTarget.focus();
    handleSelect();
  };
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.key) {
      case 'Enter':
        handleSelect();
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        e.preventDefault(); // Prevent page scroll
        focusTab === null || focusTab === void 0 || focusTab(getNextIndex(focusedIndex, numTabs));
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        e.preventDefault(); // Prevent page scroll
        focusTab === null || focusTab === void 0 || focusTab(getPrevIndex(focusedIndex, numTabs));
        break;
      case 'PageUp':
      case 'Home':
        e.preventDefault(); // Prevent page scroll
        focusTab === null || focusTab === void 0 || focusTab(0);
        break;
      case 'PageDown':
      case 'End':
        e.preventDefault(); // Prevent page scroll
        focusTab === null || focusTab === void 0 || focusTab(Number(numTabs) - 1);
        break;
      default:
    }
  };
  var commonProps = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    role: 'tab',
    'aria-selected': isSelected,
    'aria-controls': ariaControls || _concatInstanceProperty(_context = "toolbar-".concat(toolbarId, "-panel-")).call(_context, index),
    id: id || _concatInstanceProperty(_context2 = "toolbar-".concat(toolbarId, "-tab-")).call(_context2, index),
    // Exsures the correct tab is focused when tabbing into the Toolbar
    tabIndex: isFocused ? 0 : -1,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    'data-testid': dataTestId || getSubDataTestId(rootDataTestId, "tab-".concat(index))
  });
  var iconButtonClassName = classNames(className, styles.toolbarTab, styles.toolbarTabIconButton, _defineProperty({}, styles.selected, isSelected));
  var iconButtonWithLabelClassName = classNames(className, styles.toolbarTab, _defineProperty({}, styles.selected, isSelected));
  var buttonWithLabelClassName = classNames(className, styles.toolbarTab, styles.buttonWithLabel, _defineProperty({}, styles.selected, isSelected));
  var iconButtonIconClassName = classNames(styles.toolbarTabIcon, _defineProperty({}, styles.selected, isSelected));
  var tabComponent;
  if (isCollapsed) {
    tabComponent = /*#__PURE__*/React__default.createElement(IconButton, _extends({}, commonProps, {
      className: iconButtonClassName,
      tooltipContent: label,
      tooltipPlacement: "right",
      "aria-label": label
    }), Icon ? /*#__PURE__*/React__default.createElement(Icon, {
      className: iconButtonIconClassName
    }) : /*#__PURE__*/React__default.createElement(ExcludeIcon, {
      className: iconButtonIconClassName,
      "aria-hidden": "true"
    }));
  } else if (Icon) {
    tabComponent = /*#__PURE__*/React__default.createElement(IconButtonWithLabel, _extends({}, commonProps, {
      className: iconButtonWithLabelClassName,
      icon: Icon,
      label: label
    }));
  } else {
    tabComponent = /*#__PURE__*/React__default.createElement("button", _extends({
      type: "button"
    }, commonProps, {
      className: buttonWithLabelClassName
    }), /*#__PURE__*/React__default.createElement("span", {
      className: styles.buttonWithLabelLabel
    }, label));
  }
  return tabComponent;
});

export { ToolbarTab as default };
